import { Box, Typography } from '@material-ui/core'

import checkoutTheme from 'theme/checkoutTheme'

import LogoMastercard from 'images/image-mastercard.svg'
import LogoVisa from 'images/image-visa.svg'
import LogoAmec from 'images/image-amec.svg'
import LogoElo from 'images/image-elo.svg'
import LogoHipercard from 'images/image-hipercard.svg'
import LogoBoleto from 'images/image-boleto.svg'
import LogoPix from 'images/image-pix.svg'
import LogoDiners from 'images/image-diners.svg'
import LogoBanes from 'images/image-banes.svg'
import LogoCabal from 'images/image-cabal.svg'
import LogoJcb from 'images/image-jcb.svg'

const PaymentMethodImages = ({ partnerGroup }) => {
  const images = [
    { name: 'mastercard', src: LogoMastercard },
    { name: 'visa', src: LogoVisa },
    { name: 'amec', src: LogoAmec },
    { name: 'elo', src: LogoElo },
    { name: 'hipercard', src: LogoHipercard },
    { name: 'boleto', src: LogoBoleto },
    { name: 'pix', src: LogoPix },
    { name: 'diners', src: LogoDiners },
    { name: 'banes', src: LogoBanes },
    { name: 'cabal', src: LogoCabal },
    { name: 'jcb', src: LogoJcb },
  ]

  return (
    <>
      <Box style={{ marginTop: '20px' }}>
        <Typography variant="body2" color="textSecondary">
          Aceitamos:
          <br />
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="flex-start"
        flexWrap="wrap"
        justifyContent="space-around"
      >
        {images?.map((image, index) => (
          <img
            key={index}
            alt={image.name}
            src={image.src}
            style={{
              flexBasis: 'calc(18% - 10px)',
              marginBottom: checkoutTheme.spacing(6),
            }}
            height="28px"
          />
        ))}
      </Box>
    </>
  )
}

export default PaymentMethodImages
